import UserPosition from './user-position'

export type PrinterShift = '1' | '2' | '3' | '4'

export type PrinterMachineColumn =
    | 'Omet 1'
    | 'MPS 1'
    | 'MPS 2'
    | 'MPS 3'
    | 'Bobst 1'
    | 'Bobst 2'
    | 'Bobst 3'
    | 'Термо 1'
    | 'DCMQ 1'
    | 'Durst 1'
    | 'WG 1'
    | 'GF 1'
    | 'GF 2'
    | 'RG 1'
    | 'DMS 1'

export interface PrinterShiftProfile {
    type: 'printer'
    data: {
        shift: PrinterShift
        machineColumn: PrinterMachineColumn
    }
}

export interface AssistantShiftProfile {
    type: 'assistant'
    data: {
        shift: PrinterShift
    }
}

export type ShiftProfile = PrinterShiftProfile | AssistantShiftProfile

export default interface User {
    id: number // 1,
    username: string // "RyzhakovRoman",
    email: string // "ryzhakov.r@mail.ru",
    provider: string // "local",
    confirmed: boolean // false,
    blocked: boolean // false,
    createdAt: string // "2024-08-16T10:59:27.863Z",
    publishedAt: string // "2024-10-31T03:43:15.972Z"
    updatedAt: string // "2024-08-16T10:59:27.863Z"
    documentId: string // "xsjqd4l7n4cg9snyxww3r3gm"
    phoneNumber?: string // "+7 (999) 999-99-99"
    role?: Role
    businessRoles?: BusinessRole[]
    user_position?: UserPosition
    shiftProfile?: ShiftProfile | null
    tasks?: { id: number }[]
    curator?: User
}

export interface Role {
    id: number // 3
    name: 'Authenticated' | 'Public' // "Manager"
    description: string // "Role of sales manager"
    type: string // "manager"
}

export enum BusinessRole {
    SuperAdmin = 'Супер Админ',
    Manager = 'Менеджер',
    SecondManager = 'Помощник менеджера',
    Designer = 'Дизайнер',
    Storekeeper = 'Кладовщик',
    StorekeeperForForms = 'Кладовщик по формам',
    StorekeeperForMaterial = 'Кладовщик по материалам',
    Colorist = 'Колорист',
    OrdersOperatorForMaterials = 'Оператор заказов материалов',
    StampOperator = 'Оператор штампов',
    Printer = 'Печатник',
    SecondPrinter = 'Помощник печатника',
    Logist = 'Логист',
    PrintTaskManager = 'Диспетчер заданий печати',
    RewindTaskManager = 'Диспетчер заданий перемотки',
    Rewinder = 'Перемотчик',
    Curator = 'Куратор',
    Corrector = 'Корректор',
}
